import React from 'react'
import UnderlaymentProductList from './UnderlaymentProductList'
import AppNavigation from '../../AppNavigation'

export default function UnderlaymentProductSelection() {
   return (
      <React.Fragment>
         <div className="col-xs-12 col-md-9 col-md-push-3">
            <UnderlaymentProductList />
         </div>
         <AppNavigation />
      </React.Fragment>
   )
}


// WEBPACK FOOTER //
// ./src/components/productTypes/underlayment/UnderlaymentProductSelection.js